let currentAdmin = null

export const ADMIN_SESSION_POLICY = {
  source: 'SERVER_COOKIE',
  enforceMaxAge: true,
}

export function setAdminSession(admin) {
  currentAdmin = admin || null
  return currentAdmin
}

export function clearAdminSession() {
  currentAdmin = null
}

export function getAdminSessionAdmin() {
  return currentAdmin
}

export function hasAdminSession() {
  return Boolean(currentAdmin)
}

// Kept for compatibility with older imports. Authentication itself is authoritative on the server cookie.
export function startAdminSession(_email = '', admin = null) {
  return setAdminSession(admin)
}

export function endAdminSession() {
  clearAdminSession()
}

export function readAdminSessionAudit() {
  return []
}
